// extracted by mini-css-extract-plugin
export default {"label":"dropdownSelect_label__jLEGS","dropDownButton":"dropdownSelect_dropDownButton__7MaFu"};